import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axios-base-query';
import APIS from '../../utils/apiUrl';
import { FirmwareTier } from '../../models/FirmwareTier';
import { BaseSearchRequest } from '../../models/shared';

export interface ListFirmwareTiersRequest extends BaseSearchRequest<FirmwareTier> {
  tierName?: string;
  invoiceProductNumber?: string;
}
/**
 * A redux-toolkit query api for firmware tiers. The toolkit manages refreshes, caching, cancellation, etc
 * via its generated react hooks (see the exports at the bottom of the file). The hooks return useful
 * helper states like loading, error, or data
 *
 * @see https://redux-toolkit.js.org/rtk-query/overview
 */
export const firmwareTiersApi = createApi({
  reducerPath: 'firmwareTiers',
  baseQuery: axiosBaseQuery({ baseUrl: APIS.SENTINEL_API }),
  tagTypes: ['firmwareTiers'],
  endpoints: builder => ({
    getFirmwareTiers: builder.query<FirmwareTier[], ListFirmwareTiersRequest>({
      query: () => ({ url: '/api/firmwareTiers/list', method: 'get' }),
    }),
  }),
});

export const {
  /** a hook to search for firmware tiers, see {@link ListFirmwareTiersRequest} for parameters */
  useGetFirmwareTiersQuery,
} = firmwareTiersApi;
